/* Church Sign Shop — design thumbnail grids (homepage featured designs, hero
   mosaic, cart "You might also want").
   Built from the shared design registry, thumbnails drawn with the
   configurator's renderer; each card deep-links into the configurator with
   that design preselected. Popular designs first, then registry order.

   Each [data-home-tpl-grid] reads the registry + config JSON from its nearest
   [data-design-scope] / <section>. Options (data attributes on the grid):
     data-limit     max designs (default 8)
     data-class     class prefix for card markup (default "home-templates")
     data-exclude   "|"-separated design names to skip (e.g. already in cart)
     data-category  only designs in this design_category handle
     data-slots     fill existing [data-slot] children in place (no names)
                    instead of building cards; untouched slots keep their
                    placeholder markup.                                     */
(function () {
  /* several sections include this script; the first run handles every grid */
  if (window.__csDesignGrids) return;
  window.__csDesignGrids = true;
  var grids = document.querySelectorAll('[data-home-tpl-grid]');
  if (!grids.length) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJson(scope, sel, fallback) {
    var el = scope.querySelector(sel) || document.querySelector(sel);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent || '') || fallback; } catch (e) { return fallback; }
  }

  var imgCache = {};
  function loadImg(url, cb) {
    var e = imgCache[url];
    if (!e) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      e = imgCache[url] = { img: im, ready: false, cbs: [] };
      im.onload = im.onerror = function () { e.ready = true; e.cbs.splice(0).forEach(function (f) { f(); }); };
      im.src = url;
    }
    if (e.ready) cb(); else e.cbs.push(cb);
  }

  var allCards = [];

  Array.prototype.forEach.call(grids, function (grid) {
    var scope = grid.closest('[data-design-scope]') || grid.closest('section') || document;
    var designs = readJson(scope, '[data-design-registry]', []);
    var cfg = Object.assign({ productUrl: '/products/custom-church-welcome-sign', print: {} },
                            readJson(scope, '[data-home-tpl-config]', {}));
    var limit = parseInt(grid.getAttribute('data-limit'), 10) || 8;
    var prefix = grid.getAttribute('data-class') || 'home-templates';
    var exclude = (grid.getAttribute('data-exclude') || '').split('|')
      .map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
    var bleedIn = parseFloat(cfg.print && cfg.print.bleedIn) || 1;
    var radiusIn = parseFloat(cfg.print && cfg.print.cornerRadiusIn);
    if (isNaN(radiusIn)) radiusIn = 1;

    /* data-category pins a grid to one design_category (homepage season slot) */
    var onlyCat = (grid.getAttribute('data-category') || '').trim();
    var pick = designs.filter(function (d) {
      if (onlyCat && d.category !== onlyCat) return false;
      return exclude.indexOf(String(d.name || '').toLowerCase()) === -1;
    }).sort(function (a, b) {
      var pa = a.popular ? 1 : 0, pb = b.popular ? 1 : 0;
      if (pb !== pa) return pb - pa;
      return (a.order || 0) - (b.order || 0);
    });

    function hrefFor(d) {
      return cfg.productUrl + '?design=' + encodeURIComponent(d.handle || d.id);
    }
    function register(card, canvas, d) {
      allCards.push({ card: card, cv: canvas, d: d, bleedIn: bleedIn, radiusIn: radiusIn });
    }

    if (grid.hasAttribute('data-slots')) {
      var slots = grid.querySelectorAll('[data-slot]');
      pick.slice(0, slots.length).forEach(function (d, i) {
        var slot = slots[i];
        slot.innerHTML =
          '<a class="' + prefix + '__link" href="' + esc(hrefFor(d)) + '" aria-label="' + esc(d.name) + '">' +
          '<canvas class="' + prefix + '__cv" width="440" height="440"></canvas></a>';
        register(slot, slot.querySelector('canvas'), d);
      });
      return;
    }

    grid.innerHTML = '';
    pick.slice(0, limit).forEach(function (d) {
      var a = document.createElement('a');
      a.className = prefix + '__card';
      a.href = hrefFor(d);
      a.innerHTML =
        '<div class="' + prefix + '__tile-wrap"><canvas class="' + prefix + '__cv" width="440" height="440"></canvas></div>' +
        '<span class="' + prefix + '__name">' + esc(d.name) + '</span>';
      grid.appendChild(a);
      register(a, a.querySelector('canvas'), d);
    });
  });

  function drawCard(c) {
    var ST = window.SignTemplates, d = c.d, cv = c.cv;
    if (!ST || !d || !cv) return;
    /* draw at the canvas's real display size (content box of its wrapper;
       offsetWidth ignores rotation) so the browser never upscales it */
    var wrap = cv.parentElement, avail = 0;
    if (wrap) {
      var cs = window.getComputedStyle(wrap);
      avail = wrap.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    }
    var cssW = Math.max(120, Math.min(640, Math.round(avail) || 260));
    if (c.drawnW === cssW && c.drawnReady) return;
    var draw = function () {
      var entry = imgCache[d.thumb || d.img];
      ST.renderPreviewInto(cv, cssW, {
        shape: 'square', bleedIn: c.bleedIn, cornerRadiusIn: c.radiusIn,
        dpr: Math.min(2, window.devicePixelRatio || 1),
        drawFull: function (ctx, ppi) {
          ST.renderOverlay({ ctx: ctx, img: entry && entry.ready ? entry.img : null,
            design: { bg: null, ink: d.ink || 'white', fields: {} },
            shape: 'square', bleedIn: c.bleedIn, ppi: ppi, sheetMatches: true, defaultBg: d.bg });
        }
      });
      cv.style.width = '100%'; cv.style.height = 'auto';
      c.drawnW = cssW;
      c.drawnReady = !(d.thumb || d.img) || !!(imgCache[d.thumb || d.img] && imgCache[d.thumb || d.img].ready);
      if (c.drawnReady) cv.classList.add('is-drawn');
    };
    /* thumbnails use the 1200px export — the 4096px print file is only for the configurator */
    if (d.thumb || d.img) loadImg(d.thumb || d.img, draw);
    if (!c.drawnReady) draw();
  }
  function drawAll() {
    if (!window.SignTemplates) { setTimeout(drawAll, 60); return; }
    var f = window.SignTemplates.loadFonts ? window.SignTemplates.loadFonts() : Promise.resolve();
    f.then(function () {
      allCards.forEach(drawCard);
      /* redraw when a card's box actually changes size (layout settling,
         breakpoints) instead of guessing from window resizes */
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(function (entries) {
          entries.forEach(function (e) { if (e.target._csCard) drawCard(e.target._csCard); });
        });
        allCards.forEach(function (c) {
          if (c.cv.parentElement) { c.cv.parentElement._csCard = c; ro.observe(c.cv.parentElement); }
        });
      } else {
        window.addEventListener('resize', function () { allCards.forEach(drawCard); });
      }
    });
  }
  drawAll();
})();
